module.exports = __webpack_public_path__ + "img/3d_cn.feed7a4.jpg";